// import Vue from 'vue'
const isServer = false

// 使dom绑定事件 兼容主流浏览器
export const on = (() => {
    if (!isServer && document.addEventListener) {
        return (element, event, handler) => {
            if (element && event && handler) {
                element.addEventListener(event, handler, false)
            }
        }
    } else {
        return (element, event, handler) => {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler)
            }
        }
    }
})()

// 使dom删除事件 兼容主流浏览器
/* istanbul ignore next */
export const off = (() => {
    if (!isServer && document.removeEventListener) {
        return (element, event, handler) => {
            if (element && event) {
                element.removeEventListener(event, handler, false)
            }
        }
    } else {
        return (element, event, handler) => {
            if (element && event) {
                element.detachEvent('on' + event, handler)
            }
        }
    }
})()

// 返回顶部
export const scrollTop = (el, from = 0, to, duration = 500) => {
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)
  scroll(el, from, to, step)
}

/**
 * [scroll 滚动条从start滚动到end]
 * @param  {[type]} el    [要滚动元素]
 * @param  {[type]} start [开始位置]
 * @param  {[type]} end   [结束位置]
 * @param  {[type]} step  [滚动的步长]
 * @return {[type]}       [description]
 */
export const scroll = (el, start, end, step = 50) => {
  if (start === end) return

  // 从上往下滚
  let d = (start + step > end) ? end : start + step
  // 从下往上滚
  if (start > end) {
    d = (start - step < end) ? end : start - step
  }

  if (el === window) {
    window.scrollTo(d, d)
  } else {
    el.scrollTop = d
  }
  requestAnimationFrame(() => scroll(el, d, end, step))
}

/**
 * [getImageNaturalSize 获取图片的真实高度]
 * @param  {[type]} img [图片dom元素]
 * @return {[type]}     [description]
 */
export function getImageNaturalSize (img) {
  return new Promise((resolve, reject) => {
    if (img.naturalWidth) {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight
      })
    } else {
      const image = new Image()
      image.src = img.src
      on(image, 'load', _ => {
        resolve(image.width, image.height)
      })
    }
  })
}
